import { useMasterData } from 'src/api/masterData'
import { createPersona } from 'src/api/persona'
import { invalidateUser, withLoginUser } from 'src/api/user'
import { Loading } from 'src/components/Loading'
import { Persona } from 'src/models/Persona/index'
import { CompanyPersonasForm } from './CompanyPersonasForm'
import { VFC, useState } from 'react'
import { GET_PERSONAS } from 'src/api/endpoints'
import { useSWRConfig } from 'swr'

export const CompanyPersonasNew: VFC<{ close: () => void }> = withLoginUser(
  ({ user, close }) => {
    const { mutate } = useSWRConfig()
    const { data: masterData } = useMasterData()
    const [errorMessages, setErrorMessages] = useState<string[]>([])
    if (!masterData) return <Loading isLoading={true} />
    const personaData: Persona = {
      id: 0,
      personaAdminAgeIds: [],
      personaBusinessObjectIds: [],
      personaEmployeeNumberIds: [],
      personaFoundedAtIds: [],
      personaPrefectureIds: [],
      personaTypeOfBusinessIds: [],
      personaCompanyBuyNeedOptionIds: [],
      personaSolutionIds: [],
      personaCapitalIds: [],
      personaPositionIds: [],
      personaRoleForAnalysisIds: [],
      refuseMessage: true,
      noMessage: true,
      isNew: false,
      isListedCompany: null,
      freeWord: null,
      minCreatedDate: null,
      maxCreatedDate: null,
      minLastSignInAt: null,
      maxLastSignInAt: null,
      personaAdminAges: [],
      personaCompanyBuyNeedOptions: [],
      personaSolutions: [],
      personaBusinessObjects: [],
      personaEmployeeNumbers: [],
      personaFoundedAts: [],
      personaPrefectures: [],
      personaTypeOfBusinesses: [],
      personaCapitals: [],
      personaPositions: [],
      personaRoleForAnalysis: [],
    }

    return (
      <CompanyPersonasForm
        user={user}
        personaData={personaData}
        masterData={masterData}
        errorMessages={errorMessages}
        submit={(data) =>
          createPersona(data).then((response) => {
            if (response.data?.success && response.data?.personaId) {
              mutate(GET_PERSONAS)
              invalidateUser() // NOTE: canCreatePersonaを再取得するため
              close()
            } else if (response.error)
              setErrorMessages(response.error.errorMessages)
          })
        }
      />
    )
  },
)
